<template>
    <light-box v-if="fullImg" :full-img="fullImg" @activeLightBox="(value) =>getDataLightbox(value)" /> 
    <div class="w-full">
        <div class="grid grid-cols-3 gap-4 ">
            <div v-for="(item, index) in dataGrid" :key="index" class="place-self-auto relative">
                <div class="wrap-img"
                @click.prevent="activeElement(item)"
                :class="index == selectedItem && active ? 'active' : ''"
                >
                <img loading="lazy" :src="item" class="object-center object-cover w-full" />
                </div>
            </div>
        </div>
    </div>
</template>
    
<script>
export default {
    name: 'grid-gallery-render',
    props: {
        dataGrid: {
            type: Array,
            default: [],
        }
    },
    data() {
        return {
            active: false,
            selectedItem: -1,
            dataParseGrid: '',
            fullImg : '',
        }

    },

    methods: {
        activeElement(item) {
            //this.active = !this.active
            const body = document.querySelector('body')
            this.fullImg = item
            body.style.overflow= 'hidden' 
        },
        getDataLightbox(isActive){
         const body = document.querySelector('body')
         this.fullImg='' 
         body.style.overflow='auto' 
        }

    },
    
    /*mounted(){
        this.dataParseGrid = JSON.parse(this.dataGrid)
    }*/
}
</script>
<style lang="scss" scoped>
.place-self-auto {
    cursor: pointer;
    transition: .8s all;
.wrap-img{
    &:hover {
        transform: scale(1.1);
        transition: .3s;
    }


    &.active {
        transform: translate(50%, -20%) scale(4);
        left:0;right:0;
        margin:auto;
        position: absolute;
        transition: .8s all;
        z-index:20;
      

    }
}
}
</style>